import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { navMenu } from 'js/constant/nav-menu'
import { NavDropdown } from 'react-bootstrap'
import styles from './styles'

const getDropdown = (item, active) => {
  const [menuOpen, toggleMenuOpen] = useState(false)
  return (<>
    <NavDropdown
      active={active === item.id}
      className={styles.dropdown_title}
      id={item.id}
      onMouseEnter={() => toggleMenuOpen(true) }
      onMouseLeave={() => toggleMenuOpen(false) }
      onToggle={() => {
        window.location.href = item.key
      }}
      show={menuOpen}
      title={item.title}
    >
      <div className={item.children[0].type === 'group' ? styles.dropdown_wrapper : ''}>
        {item.children.map((child, i) => {
          if (child.type === 'group') {
            return (<div key={i}>
              <p className={styles.group_title}>{child.label}</p>
              {child.children.map((innerChild, i) => {
                return (
                  <NavDropdown.Item
                    className={styles.inner_child}
                    disabled={innerChild.disabled}
                    href={innerChild.key}
                    key={i}
                  >{innerChild.label}</NavDropdown.Item>)
              })}
            </div>)
          } else {
            return (
              <>
                <NavDropdown.Item
                  className={styles.inner_child}
                  disabled={child.disabled}
                  href={child.key}
                  key={i}
                >{child.label}</NavDropdown.Item>
              </>)
          }
        })}
      </div>

    </NavDropdown>
  </>)
}

const Menu = ({ menuDisplay }) => {
  const [active, setActive] = useState(window.location.pathname.split('/')[1])

  return (
    <div className={styles.navbar}>
      {navMenu.map((item) => getDropdown(item, active))}
    </div>
  )
}

Menu.propTypes = {
  menuDisplay: PropTypes.string
}

export default Menu
